import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { FaChevronRight, FaCheck } from 'react-icons/fa'
import { HiDuplicate } from 'react-icons/hi'
import clsx from 'clsx'

import { numberFormatCurrency } from '../../../utils/helpers'
import useContainerContext from '../../containerContext'
import Table from '../../table'
import VehicleSummary from '../../vehicle/VehicleSummary'
import { getVehicles, summarizeVehicles } from '../../../utils/vehicleSummary'
import { formatToLocalTime } from '../../../utils/dates'
import { PAYMENT_TEXT } from '../../../core/constants/filter'
import { Tooltip } from '../../controls'

const TableMobile = () => {
	const { data = [], state, setState } = useContainerContext()
	const history = useHistory()
	return (
		<Table
			data={data}
			rowKey='_id'
			onRowClick={row => history.push(`/invoices/${row._id}`)}
			state={state}
			setState={setState}
			className='primary'
			borderless
		>
			<Table.Column
				dataKey='_id'
				render={(_id, { rowData }) => {
					const {
						company,
						number,
						payment,
						// currency = 'usd',
						total = 0,
						purchaseOrder,
						dateCreated,
						client,
					} = rowData					
					const { name } = company
					const { paid } = payment
					const active = client?._id?.group?.companyOverride?.active
					const nameClient = client?._id?.group?.companyOverride?.name
					const vehicles = getVehicles(rowData)
					const { vehicle, extraCount } = summarizeVehicles(vehicles)
					return (
						<div className='px-4 py-3 rounded'>
							<div className='d-flex justify-content-between'>
								<div>
								<h5 className='fw-bold'>{active ? nameClient : name}</h5>
									<strong className='fs-base'>
										{numberFormatCurrency(company?.currency || 'usd', total)}
									</strong>
								</div>
								<div>
									<Link to={`/invoices/${_id}`}>
										<FaChevronRight />
									</Link>
								</div>
							</div>

							<div className='fs-base mt-3'>
								<strong>Date: </strong> {formatToLocalTime(dateCreated)}
								<strong className='d-flex align-items-center gap-1'>
									Invoice #: {number}
									{/* Only show dual invoicing indicator if feature is enabled AND there's a discount */}
									{rowData?.pdf?.dualInvoicing && (rowData?.discountAmount || 0) > 0 && (
										<Tooltip
											placement='top'
											message='Dual Invoicing Enabled'
										>
											<HiDuplicate size={16} className='text-primary' />
										</Tooltip>
									)}
								</strong>
								<div className='d-flex justify-content-between'>
									<strong>PO Number: #{purchaseOrder}</strong>
									<div
										className={clsx(
											'text-white rounded-pill d-flex align-items-center px-4 fw-bold',
											{
												'bg-light': paid === 'unpaid',
												'bg-success': paid === 'paid',
												'bg-warning': paid === 'partial',
											},
										)}
										style={{ minHeight: '24px' }}
									>
										{paid === 'paid' && <FaCheck className='text-white me-2' />}
										<span className='mx-auto text-capitalize'>
											{PAYMENT_TEXT[paid.toUpperCase()]}
										</span>
									</div>
								</div>
								{vehicle && (
									<div className='pt-2'>
										<VehicleSummary vehicle={vehicle} extraCount={extraCount} />
									</div>
								)}
							</div>
						</div>
					)
				}}
			/>
		</Table>
	)
}
export default TableMobile
